import React from 'react'
import { Icon,Tag } from 'antd';
import '../../css/svr_review_react.css'

export default  (props)=>{
    const {my_data_review} = props
    /*
     {
                                "rateKey": "20250615|20250616|W|1|297|DBL.ST|OPPRAIHBD|AI||1~1~0||N@07~~250f4~-186720143~N~~~NOR~~3E63FEAE94684DF174743279490405AAUK0003000100010721bd8",
                                "rateClass": "NOR",
                                "rateType": "BOOKABLE",
                                "net": "216.27",
                                "allotment": 24,
                                "rateCommentsId": "1|137844|0",
                                "paymentType": "AT_WEB",
                                "packaging": false,
                                "boardCode": "AI",
                                "boardName": "ALL INCLUSIVE",
                                "cancellationPolicies": [
                                    {
                                        "amount": "216.27",
                                        "from": "2025-06-07T23:59:00+02:00"
                                    }
                                ],
                                "taxes": {
                                    "taxes": [
                                        {
                                            "included": false,
                                            "amount": "3.30",
                                            "currency": "EUR",
                                            "clientAmount": "3.30",
                                            "clientCurrency": "EUR"
                                        }
                                    ],
                                    "allIncluded": false
                                },
                                "rooms": 1,
                                "adults": 1,
                                "children": 0,
                                "promotions": [
                                    {
                                        "code": "322",
                                        "name": "Online check-in"
                                    }
                                ]
                            }

    */
    //code start
    let price = null
        if(my_data_review && my_data_review.price){
            price = my_data_review.price
        }

    //body start
    return (
        <div className="rev-row ">
            <div className="card card--raised with-shadow">
            <p className="sd-content"> <text> Price Summary </text></p>
            <div className="box-outer">
                <div className="box-left">
                    <text> Total </text>
                </div>

                <div className="box-right">

                    <p><text className="f19">{price.currency}{price.total?price.total :'923.46' }  </text></p>
                    <p><text className="f17sv">Include taxes and fees </text></p>


                </div>

            </div>


            <p className="sd-content"> <text> Price Information </text></p>
            <p><span style={{fontSize: "16px"}} > <Icon  style={{ color: 'rgb(206, 209, 24)' }} type="sketch-square" theme="filled" /><text style={{paddingLeft: "10px"}}>{price.tax.taxTotal?price.tax.taxTotal:'$102.34' } in taxes and fess </text></span></p>
            {/* 
            <p> <text className="tax-bl-total"> Incude {price.tax.taxTotal?price.tax.taxTotal:'$102.34' } in taxes and fess </text></p>
             */}
            <p>
            <dl>
                <dt className="tax-ib-info"><span className="nh"><text className="tax-line">  TAX </text></span></dt>
                <dd className="tax-ib-amt"><span className="n2">{price.tax.maintax?price.tax.maintax:'49.26' } </span> </dd>
            </dl>

            </p>
            <p>
            <dl>
                <dt className="tax-ib-info"><span className="nh"><text className="tax-line">  TAX CURRENCY </text></span>
                </dt>
                <dd className="tax-ib-amt"><span className="n2"> {price.tax.maintaxCurrency?price.tax.maintaxCurrency :'$' }  </span> </dd>
            </dl>
            </p>
            {/*  
            <p>
            <dl>

                <dt className="tax-ib-info"><span className="nh"><text className="tax-line"> Damage Deposit (Fully
                            refundable) </text></span></dt>
                <dd className="tax-ib-amt"><span className="n2"> {price.total?price.total :'$200.26 ' }</span> </dd>
            </dl>
            </p>
            */}
            <p className="sd-content"> <text> Cost Information </text></p>
            <p><span style={{fontSize: "16px"}} > <Icon  style={{ color: 'rgb(206, 209, 24)' }} type="sketch-square" theme="filled" /><text style={{paddingLeft: "10px"}}>  {price.net?price.net:'$102.34' } as cost </text></span></p>
           
            
            <p><span style={{fontSize: "16px"}} > <Icon  style={{ color: 'rgb(43, 127, 236)' }} type="diff" theme="filled" /><text style={{paddingLeft: "10px"}}>Damage Deposit(Fully Refun) {price.currency}{price.depositValue?price.depositValue :'200.26 ' }</text></span></p>

            </div>  
        </div>
)
}